import Button from '@atlaskit/button';
import CheckIcon from '@atlaskit/icon/glyph/check';
import CrossIcon from '@atlaskit/icon/glyph/cross';
import EditorRemoveIcon from '@atlaskit/icon/glyph/editor/remove';
import Tooltip from '@atlaskit/tooltip';
import React, { useContext, useState } from 'react';
import styled from '@emotion/styled';
import { GlobalContext } from '../../common/GlobalContext';
import { DTOCustomFieldOption } from '../../../generated-common';
import { token } from '@atlaskit/tokens';

export const DeleteConfirm = styled.div`
  display: flex;
  align-items: center;
`;
export const DeleteConfirmItem = styled.div`
  display: flex;
  align-items: center;
  margin-right: 10px;
`;
export const DeleteConfirmItem2 = styled.div`
  display: flex;
  align-items: center;
`;
export const FieldEditorDeleteOptionWithConfirm = ({
  option,
  isDisabled,
  isDisabledDueToPermission,
  onDeleted,
}: {
  option: DTOCustomFieldOption;
  isDisabled: boolean;
  isDisabledDueToPermission: boolean;
  onDeleted: (o: DTOCustomFieldOption) => void;
}) => {
  const [dialogIsOpen, setDialogIsOpen] = useState(false);
  const { t } = useContext(GlobalContext);
  const toggleDialog = () => setDialogIsOpen((prev) => !prev);
  const doDelete = () => {
    toggleDialog();
    onDeleted(option);
  };

  return (
    <div>
      <span data-e2e-delete-option-button={option.id} data-e2e-delete-option-button-disabled={isDisabled}>
        {dialogIsOpen !== true ? (
          <Tooltip content={isDisabledDueToPermission ? t('fieldEditor.deleteConfirm.tooltipDisabledDuePermission') : t('fieldEditor.deleteConfirm.tooltip')}>
            <Button
              isSelected={dialogIsOpen}
              appearance="subtle"
              isDisabled={isDisabled || isDisabledDueToPermission}
              onClick={() => toggleDialog()}
              iconBefore={
                <EditorRemoveIcon
                  label="delete option"
                  primaryColor={
                    dialogIsOpen
                      ? token('color.text.selected', '#fff')
                      : isDisabled || isDisabledDueToPermission
                      ? token('color.text.subtlest', '#ccc')
                      : token('color.text.accent.blue.bolder', '#253858')
                  }
                />
              }
            />
          </Tooltip>
        ) : (
          <DeleteConfirm>
            <DeleteConfirmItem>
              <Tooltip content={t('fieldEditor.deleteConfirm.no')}>
                <span data-e2e-delete-option-button-cancel={option.id}>
                  <Button appearance="default" onClick={() => toggleDialog()} iconBefore={<CrossIcon label="cancel" primaryColor={token('color.text.accent.blue.bolder', '#253858')} />} />
                </span>
              </Tooltip>
            </DeleteConfirmItem>
            <DeleteConfirmItem2>
              <Tooltip content={t('fieldEditor.deleteConfirm.yes')}>
                <span data-e2e-delete-option-button-confirm={option.id}>
                  <Button appearance="default" onClick={() => doDelete()} iconBefore={<CheckIcon label="confirm" primaryColor={token('color.text.accent.blue.bolder', '#253858')} />} />
                </span>
              </Tooltip>
            </DeleteConfirmItem2>
          </DeleteConfirm>
        )}
      </span>
    </div>
  );
};
